import { CreateReference, LocationTypeCode } from '@quromedical/fhir-common';
import { Location, UpdateLocation, UpdateLocationSchema } from '@quromedical/models';
import { CrudForm, SubmissionResult } from 'components/form';
import { mapReferenceToSelectOption } from 'core/forms';
import { OrganizationFetcher } from 'core/group';
import { useObjectState } from 'hooks/useObjectState';
import React from 'react';
import { strings } from 'strings';

import { createFields } from './fields';

interface GeneralFormProps {
  data: Location;
  onSubmit: (data: Omit<UpdateLocation, 'id'>) => Promise<SubmissionResult<unknown>>;
  onCancel: () => void;
  organizationFetcher: OrganizationFetcher;
  initialOrganization?: CreateReference;
}

export const GeneralForm: React.FC<GeneralFormProps> = ({
  data,
  onSubmit,
  onCancel,
  organizationFetcher,
  initialOrganization,
}) => {
  const formData = useObjectState<Partial<UpdateLocation>>({});

  const fieldData = createFields(
    organizationFetcher,
    formData.value.type || LocationTypeCode.VirtualWard,
    mapReferenceToSelectOption(initialOrganization),
    mapReferenceToSelectOption(data.parent)
  );

  const initialValues = {
    ...data,
    managingOrganization: mapReferenceToSelectOption(initialOrganization)?.value,
    parent: undefined,
  };

  return (
    <CrudForm
      cardProps={{ unsetZIndex: true }}
      title={strings.FormLabelLocationDetails}
      buttonText={strings.ButtonTextUpdate}
      fields={fieldData}
      validationSchema={UpdateLocationSchema}
      initialValues={initialValues}
      onSubmit={onSubmit}
      onChangeDebounceTime={0}
      onChange={data => {
        formData.set('type')(data.type);
      }}
      onSecondarySubmit={onCancel}
      showSecondarySubmitButton={true}
    />
  );
};
